import { YieldBucket } from "../../../../../../../../Component/Map/Layers/apple-count/apple-count-helper";
import { calibrationColorVar } from "../../../../../../../../Component/Map/Layers/apple-count/calibration/calibration-colors";
import { CalibrationItem, Coverage, MINIMUM_ITEMS } from "../Calibration.types";

const MIN_COUNT = 2;

export function getCalibrationDistribution(
  calibrationSet: CalibrationItem[],
  buckets: YieldBucket[],
) {
  const coverage: Coverage = {};
  for (let i = 0; i <= buckets.length - 1; i++) {
    const count = calibrationSet.filter(
      (item) => item.yieldCategory === i,
    ).length;
    coverage[i] = {
      count,
      minCount: MIN_COUNT,
      color: calibrationColorVar(i),
      bucketIndex: i,
    };
  }

  return coverage;
}

export function isGoalComplete(
  calibrationCount: number,
  coverage: Coverage,
): boolean {
  const everyBucketMeetsMinimum = Object.values(coverage).every(
    (item) => item.count >= item.minCount,
  );
  return calibrationCount >= MINIMUM_ITEMS && everyBucketMeetsMinimum;
}

export function getMissingSamples(coverage: Coverage): number {
  return Object.values(coverage).reduce(
    (sum, item) => sum + Math.max(0, item.minCount - item.count),
    0,
  );
}
